import attachments from './attachments'
import details from './details'
import causes from './causes'
import general from './general'

export default {
    ...attachments,
    ...details,
    ...causes,
    ...general,
}
